import React from 'react'
import styled from 'styled-components/macro'
import breakpoints from 'assets/stylesheet'

const SearchWrapper = styled.div`
  position: relative;
  &::after {
    display: ${props => (props.hideIcon ? 'none' : 'block')};
    position: absolute;
    right: 10px;
    top: 7px;
    font-family: 'Font Awesome 5 Pro' !important;
    content: '\f002' !important;
    color: #9faee5 !important;
    font-size: 24px;
  }
`

const SearchInput = styled.input`
  color: #ffffff;
  font-size: ${props => (props.size === 'large' ? '17' : '10')}px;
  line-height: 20px;
  text-align: left;
  border-radius: 4px;
  background-color: ${props => props.background || '#fff'};
  padding: 12px 40px;
  border: 0;
  margin: 0 0 0 0;
  width: 100%;
  transition: all 0.2s;
  cursor: pointer;
  border: 1px solid #9faee5;
  color: #4a4a4a;
  padding: ${props =>
    (props.size === 'small' && '7px 10px') ||
    (props.size === 'medium' && '12px 30px') ||
    (props.size === 'large' && '12px 40px')};
  padding-right: 35px;
  height: 40px;

  &:focus {
    background-color: #fff;
    border: 1px solid #9faee5;
    box-shadow: 0 0 6px 0 #003399;
    color: #4a4a4a;
  }
  &:active {
    background-color: #fff;
    border: 1px solid #9faee5;
    box-shadow: 0 0 6px 0 #003399;
    color: #4a4a4a;
  }

  &:last-child {
    margin-right: 0;
  }

  :disabled {
    background: gray;
  }

  &:focus {
    outline: none;
  }
  @media (max-width: ${breakpoints.bpTabletPx}) {
    padding: 10px;
  }
  @media (max-width: ${breakpoints.bpPhonePx}) {
    font-size: 10px;
  }
`

function SearchField({
  size = 'small',
  placeholder = 'Search keep.eu...',
  onChange,
  onFocus,
  searchFieldFontColor,
  searchFieldBorderColor,
  searchFieldFontSize,
  searchFieldHeight,
  onKeyDown,
  hideIcon,
  ...props
}: {
  size: string,
  placeholder: string,
  onChange: () => void,
  onFocus: () => void,
  searchFieldFontColor: string,
  searchFieldBorderColor: string,
  searchFieldFontSize: string,
  searchFieldHeight: string,
  onKeyDown: () => void,
  hideIcon: boolean,
  props: Array<Object>
}) {
  return (
    <SearchWrapper hideIcon={hideIcon}>
      <SearchInput
        type="text"
        placeholder={placeholder}
        size={size}
        onChange={onChange}
        onFocus={onFocus}
        inputBoxFontColor={searchFieldFontColor}
        inputBoxBorderColor={searchFieldBorderColor}
        inputBoxFontSize={searchFieldFontSize}
        inputBoxHeight={searchFieldHeight}
        onKeyDown={onKeyDown}
        {...props}
      />
    </SearchWrapper>
  )
}

export default SearchField
